import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import createLayout from 'apps/new-web/views/pages/create-layout';
import reducers from '../reducers';
import PreLoginNavigation from 'apps/new-web/views/components/header';
import PostLoginNavigation from 'apps/new-web/views/components/header/post-login-navigation';
import { connect } from 'react-redux';
import I18n from 'apps/new-web/views/components/i18n';
import Image from 'apps/new-web/views/components/image';

export class PureFusionDownloadApp extends BaseComponent {
  static get propTypes() {
    return {
      fromRegistration: PropTypes.Boolean,
      user: PropTypes.object
    };
  }

  constructor(props) {
    super(props);
  }

  static getAdditionalHeadTags() {
    return `<meta name="description" content="${ I18n.translate('Get epic workouts that are personalized for you! Top trainers teach you how to use your [fusion]. Access quicker, more effective, full-body workouts!', { 'fusion': 'NordicTrack Fusion' }) }" />`;
  }

  render() {
    return (
      <div className="fusion-download-component">
        {
          !this.props.user
            ? <PreLoginNavigation />
            : <PostLoginNavigation user={ this.props.user } />
        }
        <div className="fusion-app-copy">
          <Image
            className="fusion-logo hide-on-mobile" src={ '/pages/fusion/components/img/new-fusion-logo-color.svg' }
            alt={ I18n.translate('[ifit] [fusion]', { ifit: 'iFIT', fusion: 'Fusion' }, 'the iFIT Fusion app logo.' ) }
          />
          <Image
            className="fusion-icon" src={ '/pages/fusion/components/img/fusion-icon2.png' }
            alt={ I18n.translate('[ifit] [fusion]', { ifit: 'iFIT', fusion: 'Fusion' }, 'the iFIT Fusion app logo.' ) }
          />
          { this.props.fromRegistration
            ? <h2><I18n>Perfect! We've got you registered.</I18n></h2>
            : <h2><I18n>Perfect! Let's get started.</I18n></h2>
          }
          <p><I18n args={{ 'fusion': 'NordicTrack Fusion CST' }}>Simply download the [fusion] app to get started with your new workout machine!</I18n></p>
          <a href="https://play.google.com/store/apps/details?id=com.ifit.gondor" target="_blank">
            <Image
              className="google-play" src={ '/pages/fusion/components/img/google-play-badge_grey.jpg' }
              alt={ I18n.translate('Download the [fusion] app from [googlePlay].', { 'fusion': 'Fusion', 'googlePlay': 'Google Play' }) }
            />
          </a>
          <p className="footer-copy"><I18n>Got questions?</I18n></p>
          <a className="footer-copy" href="https://company.ifit.com/en/contact/"><I18n>Contact our customer service team.</I18n></a>
        </div>
      </div>
    );
  }
}

const FusionDownloadApp = connect(
  (state) => {
    return {
      ...state
    };
  }
)(PureFusionDownloadApp);

export default createLayout(FusionDownloadApp, reducers);
